module.exports = __webpack_public_path__ + "img/green-3-diamond-striped.3a6e51f2.svg";